import { inject, type InjectionKey } from 'vue';
import type { SearchController } from './useSearch';

export const searchKey: InjectionKey<SearchController> = Symbol('CengageSearch');

export function useSearchContext(): SearchController {
  const search = inject(searchKey);
  if (!search) throw new Error('Search context is unavailable.');
  return search;
}
